import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from './endpoint.service';
import { GetBeneficiaryResponse } from '../responses/GetBeneficiaryResponse';
import { GetBeneficiariesResponse } from '../responses/GetBeneficiariesResponse';
import { PaginationCriteria } from '../requests/PaginationCriteria';
import { AddBeneficiaryRequest } from '../requests/AddBeneficiaryRequest';
import { GetDocumentsRequest } from '../requests/GetDocumentsRequest';
import { GetBenefitDocumentsResponse } from '../responses/GetBenefitDocumentsResponse';
import { GetBenefitResponse } from '../responses/GetBenefitResponse';
import {GetBenefitCheckoutPolicyResponse} from '../responses/GetBenefitCheckoutPolicyResponse';
import { GetCardInfoRequest } from '../requests/GetCardInfoRequest';
import { GetCardInfoResponse } from '../responses/GetCardInfoResponse';
import { BaseResponse } from '../responses/BaseResponse';
import { Patch } from '../models/patch';
import { GetFixedBenefitDocumentsResponse } from '../responses/GetFixedBenefitDocumentsResponse';
import { Observable } from 'rxjs';
import { SubscriptionPaymentModel } from '../models/subscription-payments';
import { GetBenefitDetailResponse } from '../responses/GetBenefitDetailResponse';
import { GetSubcriptionPaymentsResponse } from '../responses/GetSubscriptionPaymentsResponse';
import { GetPaymentHistoryResponse } from '../responses/GetPaymentHistoryResponse';
import {GetRaiffeisenBranchesResponse} from "../responses/GetRaiffeisenBranchesResponse";


@Injectable({ providedIn: 'root' })
export class BenefitSummaryService {

  constructor(private http: HttpClient) {
  }

  getBenefit(id: number) {
    return this.http.get<GetBenefitResponse>(EndpointService.getBenefit + id);
  }

  getBenefitCheckoutPolicy(id: number) {
    return this.http.get<GetBenefitCheckoutPolicyResponse>(EndpointService.getBenefitCheckoutPolicy(id));
  }

  getRaiffeisenBranches(countyName: string) {
    return this.http.get<GetRaiffeisenBranchesResponse>(EndpointService.getRaiffeisenBranches + countyName);
  }

  getBeneficiaries(data: PaginationCriteria) {
    return this.http.post<GetBeneficiariesResponse>(EndpointService.getBeneficiaries, data);
  }

  addBeneficiary(data: AddBeneficiaryRequest) {
    return this.http.post<GetBeneficiaryResponse>(EndpointService.addBeneficiary + `?userId=${data.userId}`, data);
  }

  editBeneficiary(data: Array<Patch>, beneficiaryId: number) {
    return this.http.patch<BaseResponse>(EndpointService.editBeneficiary + `?id=${beneficiaryId}`, data);
  }

  deleteBeneficiaries(data: Array<Patch>, beneficiaryId: number) {
    return this.http.patch<BaseResponse>(EndpointService.deleteBeneficiary + `?id=${beneficiaryId}`, data);
  }

  getBenefitDocuments(data: GetDocumentsRequest) {
    return this.http.post<GetBenefitDocumentsResponse>(EndpointService.getBenefitDocuments, data);
  }

  getFixedBenefitDocuments(fixedBenefitId: number) {
    return this.http.post<GetFixedBenefitDocumentsResponse>(EndpointService.getFixedBenefitDocuments + `?CompanyFixedBenefitId=${fixedBenefitId}`, {});
  }

  // SubscriptionPaymentModel[]

  getSubscriptionPayments(benefitId: number, isBeneficiaryUsed: boolean): Observable<GetSubcriptionPaymentsResponse> {
    return this.http.post<GetSubcriptionPaymentsResponse>(EndpointService.getSubscriptionFuturePayments + `?benefitId=${benefitId}` + `&beneficiary=${isBeneficiaryUsed}`,  {});
  }

  // getOrderPayment
  getOrderPayment(orderId: number){
    return this.http.get<GetPaymentHistoryResponse>(EndpointService.getOrderPayment + `?orderId=${orderId}`);
  }
}
